module.exports = __webpack_public_path__ + "img/icon_5_34.d23ac864.png";